import { isCurrentMajorVersionViable } from 'mini-common-utils/lib/utils/isCurrentMajorVersionViable';
import { setIsInDarkMode } from '../mutators/setCurrentTheme';
import { store } from 'mini-theme/lib/store/store';

export const DARK_MODE_ACCESSIBILITY_BUG_FIX_EDGE_VERSION = 111;
export const DARK_MODE_CONSTANTS = {
    black: '#121212',
    white: '#ffffff',
    hoverBlue: '#71afe5',
    borderGrey: '#c0c0c0',
    opacity: '1',
    checkMarkColor: '#71afe5',
    selectedBG: '#1B2D39',
    flaggedBG: '#DDD59D',
    pinnedBG: '#5C8E9A',
};

const WHITE_MODE_CONSTANTS = {
    black: '#121212',
    todoTextColor: '#3e69e4',
    todoUnfocusedColor: '#767676',
    white: '#ffffff',
    opacity: '0.6',
    checkMarkColor: '#3e69e4',
    highlight: '#BDBDBD',
};

const handleDarkmodeCSSChanges = (): void => {
    const rootStyle = document.querySelector(':root') as HTMLElement;
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        rootStyle.style.setProperty('--dark-mode-bg', DARK_MODE_CONSTANTS.black);
        rootStyle.style.setProperty('--dark-mode-color', DARK_MODE_CONSTANTS.white);
        rootStyle.style.setProperty('--dark-mode-primary', DARK_MODE_CONSTANTS.white);
        rootStyle.style.setProperty('--dark-mode-neutral-secondary', DARK_MODE_CONSTANTS.white);
        rootStyle.style.setProperty('--dark-mode-hover-color', DARK_MODE_CONSTANTS.hoverBlue);
        rootStyle.style.setProperty('--dark-mode-border-color', DARK_MODE_CONSTANTS.borderGrey);
        rootStyle.style.setProperty('--dark-mode-opacity', DARK_MODE_CONSTANTS.opacity);
        rootStyle.style.setProperty('--dark-mode-label-ischecked', 'none');
        rootStyle.style.setProperty('--dark-mode-highlight', DARK_MODE_CONSTANTS.black);
        rootStyle.style.setProperty(
            '--dark-mode-label-checkmark',
            DARK_MODE_CONSTANTS.checkMarkColor
        );
        rootStyle.style.setProperty('--dark-mode-label-background', DARK_MODE_CONSTANTS.white);
    } else {
        rootStyle.style.setProperty('--dark-mode-bg', 'none');
        rootStyle.style.setProperty('--dark-mode-color', WHITE_MODE_CONSTANTS.black);
        rootStyle.style.setProperty('--dark-mode-hover-color', WHITE_MODE_CONSTANTS.black);
        rootStyle.style.setProperty('--dark-mode-primary', WHITE_MODE_CONSTANTS.todoTextColor);
        rootStyle.style.setProperty(
            '--dark-mode-neutral-secondary',
            WHITE_MODE_CONSTANTS.todoTextColor
        );
        rootStyle.style.setProperty('--dark-mode-border-color', 'none');
        rootStyle.style.setProperty('--dark-mode-opacity', WHITE_MODE_CONSTANTS.opacity);
        rootStyle.style.setProperty('--dark-mode-label-ischecked', WHITE_MODE_CONSTANTS.white);
        rootStyle.style.setProperty(
            '--dark-mode-label-checkmark',
            WHITE_MODE_CONSTANTS.checkMarkColor
        );
        rootStyle.style.setProperty('--dark-mode-label-background', WHITE_MODE_CONSTANTS.black);
        rootStyle.style.setProperty('--dark-mode-highlight', WHITE_MODE_CONSTANTS.highlight);
    }
};
export const dynamicModeChange = (): void => {
    if (isCurrentMajorVersionViable(DARK_MODE_ACCESSIBILITY_BUG_FIX_EDGE_VERSION)) {
        handleDarkmodeCSSChanges();
        setIsInDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = () => {
            setIsInDarkMode(!store.darkMode);
            handleDarkmodeCSSChanges();
        };
        mediaQuery.addEventListener('change', handleChange);
    }
};
